const store = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async getTestingItemList({ rootState }, params = {}) {
      const data = await rootState.http("/check/item/queryList", params);
      return data;
    },
    async updateItemsStatus({ rootState }, params = {}) {
      const data = await rootState.http("/check/item/updateStatusList", params);
      return data;
    },
    async saveTestItems({ rootState }, params = {}) {
      const data = await rootState.http("/check/item/saveCheckItem", params);
      return data;
    },
    async getTestItemsDetail({ rootState }, params = {}) {
      const data = await rootState.http("/check/item/getCheckItem", params);
      return data;
    },
    async getTestingTemplateList({ rootState }, params = {}) {
      const data = await rootState.http("/check/template/queryList", params);
      return data;
    },
    async updateItemTemplateStatus({ rootState }, params = {}) {
      const data = await rootState.http("/check/template/updateStatusList", params);
      return data;
    },
    async getTestingTemplateDetail({ rootState }, params = {}) {
      const data = await rootState.http("/check/template/getCheckTemplate", params);
      return data;
    },
    async saveItemTemplate({ rootState }, params = {}) {
      const data = await rootState.http("/check/template/saveCheckTemplate", params);
      return data;
    },
    async getTestOrdeList({ rootState }, params = {}) {
      const data = await rootState.http("/check/queryList", params);
      return data;
    },
    async getTestOrderDetail({ rootState }, params = {}) {
      const data = await rootState.http("/check/getCheckOrder", params);
      return data;
    },
    async saveTestOrder({ rootState }, params = {}) {
      const data = await rootState.http("/check/saveCheckOrder", params);
      return data;
    },
    async completeTestOrder({ rootState }, params = {}) {
      const data = await rootState.http("/check/completeCheckOrder", params);
      return data;
    },
    async cancelTestOrder({ rootState }, params = {}) {
      const data = await rootState.http("/check/cancelCheckOrder", params);
      return data;
    },
    async getTempTestCode({ rootState }, params = {}) {
      const data = await rootState.http("/check/getCheckOrderNo", params);
      return data;
    },
    async sendCheckReport({ rootState }, params = {}) {
      const data = await rootState.http("/check/sendReport", params);
      return data;
    },
    async checkRepeatCreateCheckOrder({ rootState }, params = {}) {
      const data = await rootState.http("/check/findTodayLastOrder", params);
      return data;
    }
  }
};

export default store;
